import HorizontalActionMenu from './horizontal';

export { HorizontalActionMenu };
